import { OrdersModel } from '@pukka/api';
import { numberUtils } from '@pukka/common/utils';
import { Text } from '@pukka/ui-components';

import ReceiptTaxGratuity from './ReceiptTaxGratuity';

interface ReceiptCountingBoxProps {
  readonly invoiceDetail: OrdersModel.OrderDetail;
}

export default function ReceiptCountingBox({ invoiceDetail }: ReceiptCountingBoxProps) {
  return (
    <div className="px-4">
      <div className="flex justify-between py-1">
        <Text weight="semibold">Subtotal</Text>
        <Text weight="semibold" className="w-40 text-right">
          {numberUtils.formatCurrency(invoiceDetail.subtotal, 'Rp.')}
        </Text>
      </div>

      {invoiceDetail.order_gratuities.length > 0 && (
        <ReceiptTaxGratuity data={invoiceDetail.order_gratuities} includeGratuityTax={invoiceDetail.include_gratuity_tax} />
      )}

      {invoiceDetail.order_taxes.length > 0 && (
        <ReceiptTaxGratuity data={invoiceDetail.order_taxes} includeGratuityTax={invoiceDetail.include_gratuity_tax} />
      )}

      {Boolean(parseInt(invoiceDetail.total_rounding_amount as unknown as string, 10)) && (
        <div className="flex justify-between py-1">
          <Text variant="body-1">Rounding</Text>
          <Text variant="body-1" className="w-40 text-right">
            {numberUtils.formatCurrency(invoiceDetail.total_rounding_amount, 'Rp.')}
          </Text>
        </div>
      )}
    </div>
  );
}
